// eslint-disable-next-line import/prefer-default-export
export const HUB_CARD_VARIANT = {
  IMAGE_CTA: `imageCta`,
  DUAL_COLUMN_CTA: `dualColumnCta`,
  LINK: `link`,
}
